import { createTestId } from '../../common/selectors';

export const companyScreenTestId = createTestId('company-screen');
export const companyScreenSubHeaderTestId = createTestId('company-sub-header');
